import { render, staticRenderFns } from "./BlogDetailPage.vue?vue&type=template&id=1a1e8d3c&scoped=true&"
import script from "./BlogDetailPage.vue?vue&type=script&lang=js&"
export * from "./BlogDetailPage.vue?vue&type=script&lang=js&"
import style0 from "./BlogDetailPage.vue?vue&type=style&index=0&id=1a1e8d3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1e8d3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VImg,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle})
